import { render, staticRenderFns } from "./PdfBasicQualifications.vue?vue&type=template&id=dbb9beae&scoped=true&"
import script from "./PdfBasicQualifications.vue?vue&type=script&lang=js&"
export * from "./PdfBasicQualifications.vue?vue&type=script&lang=js&"
import style0 from "./PdfBasicQualifications.vue?vue&type=style&index=0&id=dbb9beae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb9beae",
  null
  
)

export default component.exports